// Gegenereerd bestand - NIET BEWERKEN!
// WEL inchecken in Git!

export enum Roles {
    AccessTestEnvironment = 'accessTestEnvironment',
    AfasAuth = 'afasAuth',
    AiReports = 'aiReports',
    AreaManagement = 'areaManagement',
    Asphalt = 'asphalt',
    AsphaltPlanningBroer = 'asphaltPlanningBroer',
    Asphaltcoordinator = 'asphaltcoordinator',
    Asphaltexecutor = 'asphaltexecutor',
    Codalt = 'codalt',
    Commerce = 'commerce',
    CompactMachinist = 'compactMachinist',
    Construction = 'construction',
    Consumer = 'consumer',
    CraneMachinist = 'craneMachinist',
    Customer = 'customer',
    CustomerProjectsAccess = 'customerProjectsAccess',
    DirkRead = 'dirkRead',
    DirkWithCode = 'dirkWithCode',
    DirkWithPassword = 'dirkWithPassword',
    Employee = 'employee',
    EmployeeBlast = 'employeeBlast',
    EmployeeInventorize = 'employeeInventorize',
    EmployeeMarkings = 'employeeMarkings',
    EmployeeWipe = 'employeeWipe',
    Executor = 'executor',
    Executors = 'executors',
    Foreman = 'foreman',
    ForemanBlast = 'foremanBlast',
    ForemanInventorize = 'foremanInventorize',
    ForemanMarkings = 'foremanMarkings',
    ForemanWipe = 'foremanWipe',
    FormerEmployee = 'formerEmployee',
    HourCheckRestricted = 'hourCheckRestricted',
    Hourcheck = 'hourcheck',
    HourcheckBuitenGewoon = 'hourcheckBuitenGewoon',
    HourcheckRestricted = 'hourcheckRestricted',
    HoursExtended = 'hoursExtended',
    Hourwriter = 'hourwriter',
    Hrm = 'hrm',
    Kam = 'kam',
    Leave = 'leave',
    LeaveManagement = 'leaveManagement',
    Machinist = 'machinist',
    Management = 'management',
    Marker = 'marker',
    Office = 'office',
    OtherEmployees = 'otherEmployees',
    Planner = 'planner',
    PlanningAlwaysRead = 'planningAlwaysRead',
    ProjectManagement = 'projectManagement',
    Projectmanager = 'projectmanager',
    StreetGroundTraffic = 'streetGroundTraffic',
    Supplier = 'supplier',
    Traffic = 'traffic',
    TransportPlanningReadOnly = 'transportPlanningReadOnly',
    TruckDriver = 'truckDriver',
    UserManagement = 'userManagement',
    UserManagementExternal = 'userManagementExternal',
    UserManagementInternal = 'userManagementInternal',
    Uta = 'uta',
    VkmExecutor = 'vkmExecutor',
    VkmMechanic = 'vkmMechanic',
    Wfs = 'wfs',
}
